import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";

@injectable()
export default class ReferralsClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async fetchReferral(accountId: number): Promise<IJsonResponse> {
    const response = await this.http.get(`/v1/app/referrals/${accountId}`);
    return response;
  }

  async fetchAllUserReferrals(payload: {
    page: number;
    size?: number;
  }): Promise<IJsonResponse> {
    const response = await this.http.get(`/v1/app/referrals`, payload);
    return response;
  }

  async fetchAllUserDownliners(payload: {
    page: number;
    size?: number;
  }): Promise<IJsonResponse> {
    const response = await this.http.get(
      `/v1/app/referrals/downliners`,
      payload
    );
    return response;
  }

  async fetchLeaderboard(payload: {
    startDate: string;
    endDate: string;
    page: number;
    size: number;
  }): Promise<IJsonResponse> {
    const response = await this.http.get(
      `/v1/app/referrals/weekly-leaderboard`,
      payload
    );
    return response;
  }

  async totalReferralTrade(): Promise<IJsonResponse> {
    const response = await this.http.get(`/v1/app/referrals/users/earnings`);
    return response;
  }
}
